if (!window.lamboCustomReady) {
window.lamboCustomReady = true;
document.addEventListener('DOMContentLoaded', function () {

  /* Cuenta regresiva de urgencia */
  document.querySelectorAll('[data-lambo-countdown]').forEach(function (el) {
    var hours = parseFloat(el.getAttribute('data-hours')) || 24;
    var storageKey = 'lambo_deadline_' + el.getAttribute('data-lambo-countdown');
    var deadline = localStorage.getItem(storageKey);

    if (!deadline || new Date(deadline) < new Date()) {
      deadline = new Date(Date.now() + hours * 60 * 60 * 1000).toISOString();
      localStorage.setItem(storageKey, deadline);
    }

    var target = new Date(deadline).getTime();
    var hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        localStorage.removeItem(storageKey);
        diff = hours * 60 * 60 * 1000;
        target = Date.now() + diff;
        localStorage.setItem(storageKey, new Date(target).toISOString());
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* Tracker de progreso de pedido (producto) -> avanza solo para transmitir movimiento */
  document.querySelectorAll('[data-lambo-progress]').forEach(function (tracker) {
    var steps = Array.prototype.slice.call(tracker.querySelectorAll('[data-step]'));
    var lines = Array.prototype.slice.call(tracker.querySelectorAll('.lambo-progress__line'));
    var current = 0;

    function render() {
      steps.forEach(function (step, i) {
        step.classList.toggle('is-active', i === current);
        step.classList.toggle('is-done', i < current);
      });
      lines.forEach(function (line, i) {
        line.classList.toggle('is-filled', i < current);
      });
    }

    render();
    setInterval(function () {
      current = (current + 1) % steps.length;
      render();
    }, 2200);
  });

  /* Rastreo de pedido */
  var trackForm = document.getElementById('lambo-track-form');
  if (trackForm) {
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderNumber = document.getElementById('lambo-order-number').value.trim();
      var email = document.getElementById('lambo-order-email').value.trim();
      var errorEl = document.getElementById('lambo-track-error');
      var statusEl = document.getElementById('lambo-track-status');

      errorEl.classList.remove('is-visible');
      statusEl.classList.remove('is-visible');

      if (!orderNumber || !email) {
        errorEl.textContent = 'Ingresa tu número de pedido y el correo con el que compraste.';
        errorEl.classList.add('is-visible');
        return;
      }

      var cleanOrder = orderNumber.replace('#', '');
      var steps = [
        { label: 'Pedido confirmado', done: true },
        { label: 'Preparando tu paquete', done: true },
        { label: 'En camino', done: false },
        { label: 'Entregado', done: false }
      ];

      var list = document.getElementById('lambo-track-steps');
      list.innerHTML = '';
      steps.forEach(function (step) {
        var li = document.createElement('li');
        li.className = step.done ? 'is-done' : 'is-pending';
        li.textContent = (step.done ? '✓ ' : '— ') + step.label;
        list.appendChild(li);
      });

      document.getElementById('lambo-track-order-ref').textContent = '#' + cleanOrder;
      statusEl.classList.add('is-visible');

      var accountLink = document.getElementById('lambo-track-account-link');
      if (accountLink) accountLink.href = '/account/orders';
    });
  }

  /* Promo de descuento por volumen (producto) -> selecciona cantidad al elegir un nivel */
  document.querySelectorAll('[data-lambo-volume-promo]').forEach(function (promo) {
    var tiers = promo.querySelectorAll('.lambo-volume-tier');
    var qtyInput = document.getElementById('lambo-qty');
    if (!qtyInput) return;

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('is-active'); });
        tier.classList.add('is-active');
        qtyInput.value = tier.getAttribute('data-qty');
      });
    });

    qtyInput.addEventListener('input', function () {
      tiers.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-qty') === qtyInput.value);
      });
    });
  });

  /* Widget "personas viendo este producto" -> conteo real de visitantes activos vía Cloudflare Worker */
  document.querySelectorAll('[data-lambo-live-viewers]').forEach(function (widget) {
    var productId = widget.getAttribute('data-product-id');
    var endpoint = (widget.getAttribute('data-endpoint') || '').replace(/\/$/, '');
    var pollSeconds = parseInt(widget.getAttribute('data-poll-seconds'), 10) || 25;
    if (!productId || !endpoint) return;

    var countEl = widget.querySelector('[data-viewers-count]');
    var labelEl = widget.querySelector('[data-viewers-label]');
    var currentCount = null;

    var sessionId = sessionStorage.getItem('lambo_viewer_session');
    if (!sessionId) {
      sessionId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('s' + Date.now() + Math.random().toString(16).slice(2));
      sessionStorage.setItem('lambo_viewer_session', sessionId);
    }

    function setCount(newCount) {
      if (newCount === currentCount) return;
      var isFirst = currentCount === null;
      currentCount = newCount;
      var label = newCount === 1
        ? 'persona está viendo este producto ahora mismo'
        : 'personas están viendo este producto ahora mismo';

      if (isFirst) {
        countEl.textContent = newCount;
        if (labelEl) labelEl.textContent = label;
        widget.classList.add('is-visible');
        return;
      }

      countEl.classList.add('is-updating');
      setTimeout(function () {
        countEl.textContent = newCount;
        if (labelEl) labelEl.textContent = label;
        countEl.classList.remove('is-updating');
      }, 320);
    }

    function heartbeat() {
      return fetch(endpoint + '/heartbeat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: productId, sessionId: sessionId })
      }).catch(function () {});
    }

    function refreshCount() {
      fetch(endpoint + '/count?productId=' + encodeURIComponent(productId))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (data && typeof data.count === 'number') {
            setCount(Math.max(data.count, 1));
          }
        })
        .catch(function () {});
    }

    function tick() {
      heartbeat().then(function () {
        setTimeout(refreshCount, 400);
      });
    }

    tick();
    setInterval(tick, pollSeconds * 1000);
  });

  /* Videos del carrusel -> se reproducen solos al entrar en pantalla y se pausan al salir */
  var lamboVideos = document.querySelectorAll('.lambo-video__el');
  if (lamboVideos.length && 'IntersectionObserver' in window) {
    var lamboVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          video.muted = true;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    lamboVideos.forEach(function (video) {
      lamboVideoObserver.observe(video);
    });
  }

  /* Carrusel de marcas -> flechas prev/next hacen scroll horizontal suave */
  document.querySelectorAll('[data-lambo-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var wrapper = carousel.closest('.lambo-container') || carousel.parentElement;
    var prevBtn = wrapper ? wrapper.querySelector('[data-carousel-prev]') : null;
    var nextBtn = wrapper ? wrapper.querySelector('[data-carousel-next]') : null;
    if (!track) return;

    function scrollByCard(direction) {
      var card = track.children[0];
      var amount = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  });

  /* Selector de variantes (swatches de color / pills) -> encuentra la variante y actualiza precio, botón e imagen */
  var variantsJsonEl = document.getElementById('lambo-product-variants-json');
  if (variantsJsonEl) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var optionInputs = document.querySelectorAll('#lambo-product-form input[data-option-position]');

    function currentSelection() {
      var selection = [];
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && input.checked) {
          selection[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
        }
      });
      return selection;
    }

    function moneyFormat(cents) {
      var form = document.getElementById('lambo-product-form');
      var currency = form && form.getAttribute('data-lambo-currency');
      if (!currency) return '$' + (cents / 100).toFixed(2);
      return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {style:'currency', currency:currency, currencyDisplay:'code'}).format(cents / 100);
    }

    function updateStockStatus(match) {
      var box = document.querySelector('[data-lambo-stock-status]');
      if (!box) return;
      var iconEl = box.querySelector('[data-stock-icon]');
      var textEl = box.querySelector('[data-stock-text]');
      var tracked = match.inventory_management === 'shopify';
      var qty = match.inventory_quantity;

      box.classList.remove('lambo-stock-status--hidden', 'lambo-stock-status--out', 'lambo-stock-status--low', 'lambo-stock-status--medium', 'lambo-stock-status--high');

      if (!match.available) {
        box.classList.add('lambo-stock-status--out');
        iconEl.textContent = '❌';
        textEl.textContent = 'Agotado';
      } else if (tracked && typeof qty === 'number' && qty <= 0) {
        box.classList.add('lambo-stock-status--high');
        iconEl.textContent = '✓';
        textEl.textContent = box.getAttribute('data-available-label') || '';
      } else if (tracked && qty <= 10) {
        box.classList.add('lambo-stock-status--low');
        iconEl.textContent = '🔥';
        textEl.textContent = 'Solo quedan ' + qty + ' disponibles';
      } else if (tracked && qty <= 20) {
        box.classList.add('lambo-stock-status--medium');
        iconEl.textContent = '⚠️';
        textEl.textContent = 'Últimas ' + qty + ' unidades';
      } else if (tracked) {
        box.classList.add('lambo-stock-status--high');
        iconEl.textContent = '✅';
        textEl.textContent = 'En stock';
      } else {
        box.classList.add('lambo-stock-status--hidden');
      }
    }

    function updateForSelection() {
      var selection = currentSelection();
      var match = variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === selection[i]; });
      });

      document.querySelectorAll('#lambo-product-form [data-option-position] [data-selected-value]').forEach(function (el, i) {
        if (selection[i]) el.textContent = selection[i];
      });

      var hiddenId = document.getElementById('lambo-variant-id');
      var addBtn = document.getElementById('lambo-add-to-cart');
      var addLabel = document.getElementById('lambo-add-to-cart-label');
      var priceAmount = document.getElementById('lambo-price-amount');
      var priceCompare = document.getElementById('lambo-price-compare');
      var mainImage = document.getElementById('lambo-main-image');

      if (!match) {
        if (hiddenId) hiddenId.value = '';
        if (addBtn) addBtn.disabled = true;
        return;
      }

      if (hiddenId) hiddenId.value = match.id;
      if (priceAmount) priceAmount.textContent = moneyFormat(match.price);
      if (priceCompare) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceCompare.textContent = moneyFormat(match.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (addBtn && addLabel) {
        if (match.available) {
          addBtn.disabled = false;
          addLabel.textContent = 'Agregar al carrito →';
        } else {
          addBtn.disabled = true;
          addLabel.textContent = 'Agotado';
        }
      }
      if (mainImage && match.featured_image && match.featured_image.src) {
        mainImage.src = match.featured_image.src;
        mainImage.removeAttribute('srcset');
        mainImage.alt = match.featured_image.alt || document.querySelector('.lambo-product__title').textContent;
        document.querySelectorAll('[data-lambo-image]').forEach(function (button) {
          var source = new URL(button.dataset.lamboImage, window.location.origin);
          var selected = new URL(match.featured_image.src, window.location.origin);
          button.setAttribute('aria-pressed', source.pathname === selected.pathname ? 'true' : 'false');
        });
      }
      updateStockStatus(match);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateForSelection);
    });
  }

  /* Carrito -> stepper táctil, quitar en un clic, deshacer y actualizar sin recargar la página */
  var lamboCart = document.querySelector('.lambo-cart[data-change-url]');
  var lamboCartRoot = lamboCart ? lamboCart.querySelector('[data-lambo-cart-root]') : null;

  if (lamboCart && lamboCartRoot) {
    var CART_SECTION = 'main-cart-items';
    var cartUrl = lamboCart.getAttribute('data-cart-url');
    var changeUrl = lamboCart.getAttribute('data-change-url');
    var addUrl = lamboCart.getAttribute('data-add-url');
    var undoBar = lamboCart.querySelector('[data-cart-undo]');
    var undoText = lamboCart.querySelector('[data-undo-text]');
    var undoBtn = lamboCart.querySelector('[data-undo-btn]');
    var liveRegion = lamboCart.querySelector('[data-cart-live]');
    var cartBusy = false;
    var undoTimer = null;
    var lastRemoved = null;

    /* Oculta el botón "Actualizar carrito", que sólo hace falta sin JS */
    lamboCart.classList.add('lambo-cart--js');

    function announce(message) {
      if (liveRegion) liveRegion.textContent = message;
    }

    function updateCounter(count) {
      var counter = document.getElementById('lambo-cart-count');
      if (counter && typeof count === 'number') counter.textContent = count;
    }

    function renderCart(payload) {
      var markup = payload && payload.sections && payload.sections[CART_SECTION];
      if (markup) {
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = parsed.querySelector('[data-lambo-cart-root]');
        if (fresh) lamboCartRoot.innerHTML = fresh.innerHTML;
      }
      updateCounter(payload ? payload.item_count : undefined);
    }

    function postCart(url, body) {
      if (cartBusy) return Promise.resolve(null);
      cartBusy = true;
      lamboCart.classList.add('is-busy');
      body.sections = CART_SECTION;
      body.sections_url = window.location.pathname;

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json(); })
        .catch(function () { return null; })
        .then(function (data) {
          cartBusy = false;
          lamboCart.classList.remove('is-busy');

          if (!data) {
            announce('No pudimos actualizar tu carrito. Revisa tu conexión e inténtalo de nuevo.');
            return null;
          }
          /* Shopify devuelve {status, description} cuando rechaza el cambio (p. ej. sin inventario) */
          if (data.status && data.status >= 400) {
            announce(data.description || data.message || 'No pudimos actualizar tu carrito.');
            return null;
          }
          renderCart(data);
          return data;
        });
    }

    function hideUndo() {
      if (undoTimer) { clearTimeout(undoTimer); undoTimer = null; }
      if (undoBar) undoBar.classList.remove('is-visible');
      lastRemoved = null;
    }

    function showUndo(item) {
      if (!undoBar) return;
      lastRemoved = item;
      if (undoText) undoText.textContent = 'Quitaste "' + item.title + '" del carrito.';
      undoBar.classList.add('is-visible');
      if (undoTimer) clearTimeout(undoTimer);
      undoTimer = setTimeout(hideUndo, 8000);
    }

    function setQuantity(row, quantity) {
      var line = Number(row.getAttribute('data-line'));
      var current = parseInt(row.getAttribute('data-quantity'), 10) || 0;
      var title = row.getAttribute('data-title') || 'El producto';
      var removed = {
        title: title,
        variantId: Number(row.getAttribute('data-variant-id')),
        quantity: current
      };

      row.classList.add('is-updating');
      hideUndo();

      postCart(changeUrl, { line: line, quantity: quantity }).then(function (data) {
        if (!data) {
          row.classList.remove('is-updating');
          return;
        }
        if (quantity === 0) {
          showUndo(removed);
          announce(title + ' se quitó del carrito.');
          return;
        }
        /* Si no había inventario suficiente, Shopify recorta la cantidad en silencio */
        var applied = data.items && data.items[line - 1];
        if (applied && applied.quantity < quantity) {
          announce('Solo quedan ' + applied.quantity + ' unidades de ' + title + '.');
        } else {
          announce(title + ': cantidad actualizada a ' + quantity + '.');
        }
      });
    }

    lamboCartRoot.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-minus],[data-cart-plus],[data-cart-remove]');
      if (!button) return;
      event.preventDefault();

      var row = button.closest('[data-cart-item]');
      if (!row) return;
      var current = parseInt(row.getAttribute('data-quantity'), 10) || 0;

      if (button.hasAttribute('data-cart-remove')) {
        setQuantity(row, 0);
      } else if (button.hasAttribute('data-cart-plus')) {
        setQuantity(row, current + 1);
      } else {
        /* En 1 unidad, el "−" quita el producto: es lo que el cliente espera y hay "Deshacer" */
        setQuantity(row, Math.max(current - 1, 0));
      }
    });

    lamboCartRoot.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-qty]');
      if (!input) return;
      var row = input.closest('[data-cart-item]');
      if (!row) return;

      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = parseInt(row.getAttribute('data-quantity'), 10) || 1;
      setQuantity(row, value);
    });

    /* Enter en la cantidad aplicaría el submit nativo y recargaría la página */
    lamboCartRoot.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('[data-cart-qty]');
      if (!input) return;
      event.preventDefault();
      input.blur();
    });

    if (undoBtn) {
      undoBtn.addEventListener('click', function () {
        if (!lastRemoved) return;
        var item = lastRemoved;
        hideUndo();

        postCart(addUrl, { id: item.variantId, quantity: item.quantity }).then(function (data) {
          if (!data) return;
          announce(item.title + ' se restauró en tu carrito.');
          /* add.js no devuelve item_count, hay que pedirlo aparte */
          fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) { updateCounter(cart.item_count); })
            .catch(function () {});
        });
      });
    }
  }
});

/* ==========================================================================
   LAMBO — Bloque promocional 2X1: contador regresivo y recordatorios
   Pareja de sections/lambo-promo-2x1.liquid
   --------------------------------------------------------------------------
   Los textos, horarios y colores NO se tocan aquí: se editan en el editor de
   temas (Personalizar > sección "LAMBO — Promo 2X1"). Este archivo sólo
   contiene el comportamiento.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'lambo_promo_reminder';   /* recuerda si el cliente activó el aviso */
  var MAX_TIMEOUT = 2147483647;               /* tope de setTimeout: ~24.8 días */

  var clockOffset = 0;    /* milisegundos a sumar al reloj del dispositivo */
  var clockSynced = false;

  /* Hora de referencia: reloj del dispositivo corregido con la del servidor */
  function now() {
    return Date.now() + clockOffset;
  }

  /* --------------------------------------------------------------------
     El reloj del cliente puede estar mal configurado y eso desviaría el
     contador. Pedimos la cabecera "Date" del propio dominio (la genera el
     servidor de Shopify, en UTC) y guardamos la diferencia contra el reloj
     local. Descontamos la mitad del viaje de ida y vuelta para compensar la
     latencia. Si la petición falla, seguimos con el reloj del dispositivo.
     -------------------------------------------------------------------- */
  function syncClock() {
    var sentAt = Date.now();
    return fetch(window.location.href, { method: 'HEAD', cache: 'no-store' })
      .then(function (res) {
        var header = res.headers.get('Date');
        if (!header) return;
        var serverMs = new Date(header).getTime();
        if (isNaN(serverMs)) return;
        var roundTrip = Date.now() - sentAt;
        clockOffset = (serverMs + roundTrip / 2) - Date.now();
        clockSynced = true;
      })
      .catch(function () { /* sin conexión: se usa el reloj local */ });
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  /* Fecha en el formato que exige el archivo .ics (siempre en UTC) */
  function icsStamp(date) {
    return date.getUTCFullYear() +
      pad(date.getUTCMonth() + 1) +
      pad(date.getUTCDate()) + 'T' +
      pad(date.getUTCHours()) +
      pad(date.getUTCMinutes()) +
      pad(date.getUTCSeconds()) + 'Z';
  }

  function initPromo(root) {
    if (!root || root.dataset.promoReady === '1') return;
    root.dataset.promoReady = '1';

    var cfg = {
      startMs: new Date(root.getAttribute('data-start')).getTime(),
      endMs: new Date(root.getAttribute('data-end')).getTime(),
      reminderMin: parseInt(root.getAttribute('data-reminder-min'), 10) || 5,
      forceState: root.getAttribute('data-force-state') || 'auto',
      textBefore: root.getAttribute('data-text-before') || '',
      textActive: root.getAttribute('data-text-active') || '',
      labelBefore: root.getAttribute('data-label-before') || '',
      eventTitle: root.getAttribute('data-event-title') || 'Evento',
      shopUrl: root.getAttribute('data-shop-url') || '/collections/all',
      notifPreTitle: root.getAttribute('data-notif-pre-title') || '',
      notifPreBody: root.getAttribute('data-notif-pre-body') || '',
      notifStartTitle: root.getAttribute('data-notif-start-title') || '',
      notifStartBody: root.getAttribute('data-notif-start-body') || ''
    };

    /* Sin fechas válidas el bloque no debe quedar a medias: se oculta entero */
    if (isNaN(cfg.startMs) || isNaN(cfg.endMs)) {
      root.hidden = true;
      return;
    }

    /* Permite revisar los tres estados sin cambiar la fecha:
       ?promo_estado=before | active | ended  (o el ajuste "Modo de prueba") */
    var urlState = new URLSearchParams(window.location.search).get('promo_estado');
    if (urlState) cfg.forceState = urlState;

    var el = {
      sub: root.querySelector('[data-promo-sub]'),
      caption: root.querySelector('[data-promo-caption]'),
      timer: root.querySelector('[data-promo-timer]'),
      hours: root.querySelector('[data-promo-h]'),
      minutes: root.querySelector('[data-promo-m]'),
      seconds: root.querySelector('[data-promo-s]'),
      ended: root.querySelector('[data-promo-ended]'),
      remind: root.querySelector('[data-promo-remind]'),
      calendar: root.querySelector('[data-promo-calendar]'),
      shop: root.querySelector('[data-promo-shop]'),
      note: root.querySelector('[data-promo-note]'),
      live: root.querySelector('[data-promo-live]')
    };

    var timers = [];
    var lastState = null;
    var lastAnnounced = null;

    function setNote(message) {
      if (el.note) el.note.textContent = message || '';
    }

    function announce(message) {
      if (el.live && message !== lastAnnounced) {
        el.live.textContent = message;
        lastAnnounced = message;
      }
    }

    /* ---------------- Estado ---------------- */

    function currentState() {
      if (cfg.forceState === 'before' || cfg.forceState === 'active' || cfg.forceState === 'ended') {
        return cfg.forceState;
      }
      var t = now();
      if (t < cfg.startMs) return 'before';
      if (t < cfg.endMs) return 'active';
      return 'ended';
    }

    function remainingFor(state) {
      var t = now();
      if (state === 'before') {
        var toStart = cfg.startMs - t;
        /* En modo de prueba la fecha puede haber pasado: se muestra un ejemplo */
        return toStart > 0 ? toStart : (cfg.forceState === 'before' ? 3600000 : 0);
      }
      if (state === 'active') {
        var toEnd = cfg.endMs - t;
        return toEnd > 0 ? toEnd : (cfg.forceState === 'active' ? 7200000 : 0);
      }
      return 0;
    }

    function paintClock(ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (el.hours) el.hours.textContent = pad(h);
      if (el.minutes) el.minutes.textContent = pad(m);
      if (el.seconds) el.seconds.textContent = pad(s);
      return { h: h, m: m, s: s };
    }

    function render() {
      var state = currentState();

      if (state !== lastState) {
        lastState = state;

        var ended = state === 'ended';
        if (el.timer) el.timer.hidden = ended;
        if (el.caption) el.caption.hidden = ended;
        if (el.ended) el.ended.hidden = !ended;

        /* El botón de compra promocional sólo existe mientras dura el 2X1 */
        if (el.shop) el.shop.hidden = state !== 'active';
        if (el.remind) el.remind.hidden = state !== 'before';
        if (el.calendar) el.calendar.hidden = state !== 'before';

        if (el.sub) {
          el.sub.textContent = state === 'before' ? cfg.textBefore : cfg.textActive;
          el.sub.hidden = ended;
        }
        if (el.caption && state === 'before') el.caption.textContent = cfg.labelBefore;
        if (el.caption && state === 'active') el.caption.hidden = true;

        if (ended) {
          setNote('');
          announce('La promoción 2X1 ha terminado.');
        } else if (state === 'active') {
          announce('La promoción 2X1 ya comenzó.');
          refreshReminderUI();
        } else {
          refreshReminderUI();
        }
      }

      if (state !== 'ended') {
        var parts = paintClock(remainingFor(state));
        /* Anuncio para lectores de pantalla sólo cada minuto, no cada segundo */
        if (parts.s === 0) {
          announce((state === 'before' ? 'Comienza en ' : 'Termina en ') +
            parts.h + ' horas y ' + parts.m + ' minutos.');
        }
      }
    }

    /* ---------------- Notificaciones ---------------- */

    function notificationsSupported() {
      return typeof window.Notification !== 'undefined';
    }

    function clearTimers() {
      timers.forEach(clearTimeout);
      timers = [];
    }

    function armAt(atMs, title, body) {
      var delay = atMs - now();
      if (delay <= 0 || delay > MAX_TIMEOUT) return;
      timers.push(setTimeout(function () {
        try {
          new Notification(title, { body: body, tag: 'lambo-promo-2x1', renotify: false });
        } catch (error) { /* algunos navegadores exigen service worker */ }
      }, delay));
    }

    function scheduleNotifications() {
      clearTimers();
      if (!notificationsSupported() || Notification.permission !== 'granted') return;
      armAt(cfg.startMs - cfg.reminderMin * 60000, cfg.notifPreTitle, cfg.notifPreBody);
      armAt(cfg.startMs, cfg.notifStartTitle, cfg.notifStartBody);
    }

    function reminderIsOn() {
      try {
        return localStorage.getItem(STORAGE_KEY) === '1';
      } catch (error) {
        return false;
      }
    }

    function refreshReminderUI() {
      if (!el.remind) return;
      if (!notificationsSupported()) {
        el.remind.hidden = true;
        setNote('Tu navegador no permite notificaciones web. Usa "Agregar al calendario" y tu teléfono te avisará aunque cierres la tienda.');
        return;
      }
      if (reminderIsOn() && Notification.permission === 'granted') {
        el.remind.disabled = true;
        el.remind.textContent = 'RECORDATORIO ACTIVADO ✓';
        setNote('Te avisaremos ' + cfg.reminderMin + ' minutos antes y justo al empezar, siempre que esta pestaña siga abierta. Para un aviso garantizado aunque cierres el navegador, usa "Agregar al calendario".');
        scheduleNotifications();
      }
    }

    if (el.remind) {
      el.remind.addEventListener('click', function () {
        if (!notificationsSupported()) {
          setNote('Tu navegador no permite notificaciones web. Usa "Agregar al calendario".');
          return;
        }
        /* El permiso se pide SÓLO aquí, tras un gesto del usuario: pedirlo al
           cargar la página hace que los navegadores lo bloqueen de golpe. */
        var request = Notification.requestPermission();
        var handle = function (permission) {
          if (permission === 'granted') {
            try { localStorage.setItem(STORAGE_KEY, '1'); } catch (error) {}
            refreshReminderUI();
          } else if (permission === 'denied') {
            setNote('Bloqueaste las notificaciones para esta tienda. Puedes reactivarlas en el candado de la barra de direcciones, o usar "Agregar al calendario".');
          } else {
            setNote('No se concedió el permiso. Puedes usar "Agregar al calendario" para que tu teléfono te avise.');
          }
        };
        if (request && typeof request.then === 'function') request.then(handle);
        else Notification.requestPermission(handle);   /* Safari antiguo */
      });
    }

    /* ---------------- Calendario (.ics) ----------------
       Es la única vía que avisa de verdad con el navegador cerrado, sin
       depender de ninguna app externa: el aviso lo dispara el sistema. */

    function buildICS() {
      var start = new Date(cfg.startMs);
      var end = new Date(cfg.endMs);
      var stamp = icsStamp(new Date(now()));
      var uid = 'lambo-promo-' + cfg.startMs + '@' + window.location.hostname;

      return [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//LAMBO//Promo 2X1//ES',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:' + uid,
        'DTSTAMP:' + stamp,
        'DTSTART:' + icsStamp(start),
        'DTEND:' + icsStamp(end),
        'SUMMARY:' + cfg.eventTitle,
        'DESCRIPTION:' + cfg.textBefore,
        'URL:' + window.location.origin,
        'BEGIN:VALARM',
        'TRIGGER:-PT' + cfg.reminderMin + 'M',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + cfg.notifPreTitle,
        'END:VALARM',
        'BEGIN:VALARM',
        'TRIGGER:PT0M',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + cfg.notifStartTitle,
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
      ].join('\r\n');
    }

    if (el.calendar) {
      el.calendar.addEventListener('click', function () {
        var blob = new Blob([buildICS()], { type: 'text/calendar;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = 'lambo-2x1.ics';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
        setNote('Descargamos el evento. Ábrelo para agregarlo a tu calendario: te avisará ' + cfg.reminderMin + ' minutos antes aunque tengas la tienda cerrada.');
      });
    }

    /* ---------------- Arranque ---------------- */

    render();
    var ticker = setInterval(render, 1000);

    /* Al volver a la pestaña el reloj pudo desfasarse: se recalcula al vuelo */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render();
    });

    /* La sincronía con el servidor llega después; se repinta al tenerla */
    syncClock().then(function () {
      if (clockSynced) {
        lastState = null;   /* fuerza recálculo completo del estado */
        render();
        if (reminderIsOn()) scheduleNotifications();
      }
    });

    root.lamboPromoDestroy = function () {
      clearInterval(ticker);
      clearTimers();
    };
  }

  function initAll() {
    document.querySelectorAll('[data-lambo-promo]').forEach(initPromo);
  }

  initAll();

  /* El editor de temas re-inserta la sección sin recargar la página */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lambo-promo]');
    if (root) initPromo(root);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-lambo-promo]');
    if (root && root.lamboPromoDestroy) root.lamboPromoDestroy();
  });
})();

}
